<template>
  <div class="service-item" :class="[`service-item--${status}`, {[`service-item--${customPeer}`]: customPeer}]">

    <vs-button
      v-if="status === 'ready_to_add'"
      class="service-item__add"
      type="flat"
      icon="add"
      size="large"
      :to="{name: pageNameToAdd, params: {name: channelSlug}}"
      color="dark"></vs-button>
    <div v-else class="service-item__peer"></div>

    <div>
      <div class="service-item__icon">
        <img :src="icon" :alt="'logo ' + title">
      </div>
      <div class="service-item__title">{{ title }}</div>
      <div class="service-item__status" v-html="statusText"></div>
      <div v-if="customText" class="service-item__option">{{ customText }}</div>
    </div>

    <div v-if="status !== 'ready_to_add' && status !== 'disabled'" class="service-item__actions">
      <vs-button
        type="flat"
        size="large"
        icon-pack="feather"
        icon="icon-edit"
        :to="{name: pageNameToEdit, params: {scenarioSlug: channelSlug}}"
      />
      <vs-button
        type="flat"
        size="large"
        icon-pack="feather"
        icon="icon-trash-2"
        @click.prevent="handleClickDelete"
      />
      <vs-dropdown vs-trigger-click v-if="redirectLink || embedScript">
        <vs-button
          v-if="status === 'online'"
          type="flat"
          size="large"
          icon-pack="feather"
          icon="icon-code"
        />
        <vs-dropdown-menu>
          <div class="dropdown-custom dropdown-custom--full">
            <div class="mb-6" v-if="redirectLink">
              <h6 class="mb-2">Ссылка на чат</h6>
              <div class="flex items-center">
                <vs-textarea
                  class="m-0 mr-4 w-full"
                  rows="1"
                  :value="redirectLink"
                  :readonly="true"
                  ref="redirect_link"
                />
                <vs-button
                  icon-pack="feather"
                  type="flat"
                  size="medium"
                  icon="icon-copy"
                  @click.prevent="handleClickCopy($refs.redirect_link.$el)"
                />
              </div>
            </div>
            <div class="mb-6" v-if="embedScript">
              <h6 class="mb-2">Код для вставки</h6>
              <div class="flex items-center">
                <vs-textarea
                  class="m-0 mr-4 w-full"
                  :value="embedScriptComputed"
                  :readonly="true"
                  ref="embed_script"
                />
                <vs-button
                  icon-pack="feather"
                  type="flat"
                  size="medium"
                  icon="icon-copy"
                  @click.prevent="handleClickCopy($refs.embed_script.$el)"
                />
              </div>
              <div class="flex mt-6" v-if="embedOptions">
                <vs-radio v-model="options.position" vs-value="" class="mr-4">Справа внизу</vs-radio>
                <vs-radio v-model="options.position" vs-value="left bottom" class="mr-4">Слева внизу</vs-radio>
                <vs-radio v-model="options.position" vs-value="left top" class="mr-4">Слева вверху</vs-radio>
                <vs-radio v-model="options.position" vs-value="right top" class="mr-4">Справа вверху</vs-radio>
              </div>
            </div>
          </div>
        </vs-dropdown-menu>
      </vs-dropdown>

      <vs-dropdown
        v-if="webHookUrl"
        vs-trigger-click
      >
        <vs-button
          type="flat"
          size="large"
          icon-pack="feather"
          icon="icon-minimize"
        />

        <vs-dropdown-menu>
          <div class="dropdown-custom dropdown-custom--full">
            <div class="mb-6">
              <h6 class="mb-2">Webhook URL</h6>
              <div class="flex items-center">
                <vs-textarea
                  class="m-0 mr-4 w-full"
                  rows="2"
                  :value="webHookUrl"
                  :readonly="true"
                  ref="webhook_url"
                />
                <vs-button
                  icon-pack="feather"
                  type="flat"
                  size="medium"
                  icon="icon-copy"
                  @click.prevent="handleClickCopy($refs.webhook_url.$el)"
                />
              </div>
            </div>
          </div>
        </vs-dropdown-menu>
      </vs-dropdown>

      <vs-dropdown
        vs-trigger-click
        v-if="templates && templates.length"
      >
        <vs-button
          type="flat"
          size="large"
          icon-pack="feather"
          icon="icon-list"
        />

        <vs-dropdown-menu>
          <div class="dropdown-custom h-128 overflow-scroll">
            <div class="mb-6">
              <vx-tooltip style="margin-right: -16px" text="Перезагрузить шаблоны" position="right" delay=".3s">
                <vs-button
                  type="flat"
                  size="large"
                  icon-pack="feather"
                  icon="icon-repeat"
                  class="absolute top-0 right-0"
                  @click="updateTemplates"
                />
              </vx-tooltip>
              <h5 class="mb-2 font-bold">Шаблоны</h5>
              <div class="flex items-center">
                <ul class="flex flex-wrap">
                  <li class="w-full mb-4" v-for="template in templates" :key="template.name">
                    <h6 class="mb-2">{{ template.name }}</h6>
                    <div class="flex items-center">
                      <vs-textarea
                        class="m-0 mr-4 w-full"
                        :rows="template.template.split(/\r\n|\r|\n/).length"
                        :value="template.template"
                        :readonly="true"
                        ref="templates"
                      />
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </vs-dropdown-menu>
      </vs-dropdown>
    </div>
  </div>
</template>

<script>
import copyToClipboard from '../../../mixins/copyToClipboard'

export default {
  props: {
    status: {
      type: String,
      required: true // online | invalid | pending | disabled | ready_to_add
    },
    title: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      required: true
    },
    channelSlug: {
      type: String,
      required: true
    },
    pageNameToAdd: {
      type: String
    },
    pageNameToEdit: {
      type: String
    },
    embedScript: {
      type: String
    },
    redirectLink: {
      type: String
    },
    customText: {
      type: String
    },
    customPeer: {
      type: String
    },
    embedOptions: {
      type: Boolean
    },
    webHookUrl: {
      type: String
    },
    templates: {
      type: Array
    },
    updateTemplates: {
      type: Function
    }
  },

  mixins: [copyToClipboard],

  data () {
    return {
      statusTexts: {
        online: 'Успешно<br>подключено',
        connected: 'Успешно<br>подключено',
        invalid: 'Ошибка',
        pending: 'Идёт<br>подключение',
        disabled: 'Работаем<br>над этим',
        ready_to_add: 'Нажмите на «+»<br>чтобы подключить'
      },
      options: {
        position: ''
      }
    }
  },
  computed: {
    statusText () {
      return this.statusTexts[this.status] || ''
    },

    embedScriptComputed () {
      if (this.options.position && this.embedOptions) {
        return this.embedScript.replace('\');', `' , { position: '${this.options.position}' });`).replace('    ', '\n')
      } else {
        return this.embedScript.replace('    ', '\n')
      }
    }
  },
  methods: {
    handleClickDelete () {
      const deleting = () => {
        this.$emit('delete')
      }
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Вы действительно хотите удалить сервис из канала Yolker?',
        text: 'Сервис будет удален из системы.',
        accept: deleting,
        acceptText: 'Удалить',
        cancelText: 'Отменить'
      })
    },

    async handleClickCopy (el) {
      const copied = await this.copyToClipboard(el)
      if (copied) {
        this.$vs.notify({
          color: 'success',
          title: 'Cкопировано в буфер обмена',
          text: ''
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .service-item {
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    background: #fff;
    border-radius: .5rem;
    box-shadow: 0 4px 25px 0 rgba(0, 0, 0, .1);
    padding: 40px;
    height: 380px;
    transition: .4s ease-in-out;

    &:hover {
      transform: scale(.99);
    }

    &__peer {
      position: absolute;
      top: 20px;
      right: 20px;
      width: 10px;
      height: 10px;
      border-radius: 50%;
    }

    &__icon {
      margin-bottom: 40px;

      img {
        max-height: 70px;
      }
    }

    &__title {
      margin-bottom: 20px;
      font-weight: 500;
      font-size: 24px;
      line-height: 29px;
    }

    &__status {
      margin-bottom: .2em;
      font-weight: 300;
      font-size: 14px;
      line-height: 17px;
    }

    &__option {
      font-size: 12px;
      color: #c1c1c1;
    }

    &__actions {
      display: flex;
      align-items: center;
      align-self: center;
    }

    &--ready_to_add {
      .service-item__add {
        position: absolute;
        top: 10px;
        right: 10px;
      }
    }

    &--disabled {
      opacity: .7;
    }

    &--online, &--connected {
      .service-item__peer {
        background: #12C769;
      }

      .service-item__status {
        color: #12C769;
      }
    }

    &--invalid {
      .service-item__peer {
        background: #EC501E;
      }

      .service-item__status {
        color: #EC501E;
      }
    }

    &--pending {
      .service-item__peer {
        background: #1F5BF7;
      }

      .service-item__status {
        color: #1F5BF7;
      }
    }

    &--disable-peer {
      .service-item__peer {
        background: #cecece;
      }
    }
  }
</style>
